import React from "react";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

// The ML backend normalizes invoice/treatment dates to dd.mm.yyyy (de-CH). We
// display and store that exact format, so the saved value never changes shape.
const STORED_FORMAT = "DD.MM.YYYY";

/**
 * DateField — antd DatePicker for de-CH dates that keeps the stored string in
 * dd.mm.yyyy. Calls onChange({ target: { name, value } }) to match the existing
 * free-text input handlers, so it is a drop-in replacement for <Input>.
 */
const DateField = ({
  name,
  value,
  onChange,
  placeholder,
  disabled,
  className,
}) => {
  const parsed = value ? dayjs(value, STORED_FORMAT, true) : null;
  const pickerValue = parsed && parsed.isValid() ? parsed : null;

  const handleChange = (date) => {
    const formatted = date ? date.format(STORED_FORMAT) : "";
    onChange({ target: { name, value: formatted } });
  };

  return (
    <DatePicker
      value={pickerValue}
      onChange={handleChange}
      format={STORED_FORMAT}
      placeholder={placeholder}
      disabled={disabled}
      className={className}
      allowClear
      style={{ width: "100%" }}
    />
  );
};

export default DateField;
